/*  ==========================================================================
    MAPS
    Helper functions to create a simple map or route planner via google.

    INFO:
    - needs "bn-maps"
    - needs "jquery-inview"
    - change color of the marker in the svg file as wished

    EXAMPLES:
    - Rough html structure for a simple map:
      <div class="bn-google-maps" ide="bn-google-maps-1"></div>
    - Rough html structure for a route planner:
        <div class="bn-google-maps">
            <form action="/mapCalculate" class="bn-google-maps__form">
                <input class="bn-google-maps__start" id="bn-google-maps__start-1" placeholder="Start" type="text" value="" />
                <input class="bn-google-maps__submit" type="submit" value="Send" />
            </form>
            <div class="bn-google-maps__map" id="bn-google-maps__map-1"></div>
            <div class="bn-google-maps__directions" id="bn-google-maps__directions-1"></div>
        </div>
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import bnMaps from 'bn-maps/dist/common/js/bnmaps';
import 'jquery-inview';

// local imports
import * as vars from '../../globals/variables';

/*
 * SIMPLE MAP
 */

export function initSimpleMap($element,overrides) {
    let apiKey = $element.attr('data-api-key'),
        containerMap = $element.attr('id'),
        markerLat = $element.attr('data-lat'),
        markerLong = $element.attr('data-long'),
        markerIconUrl = $element.attr('data-marker');

    // default options
    let defaults = {
        apiKey: apiKey || false,
        language: vars.lang,
        containerMap: containerMap,
        mapConfig: {
            marker: {
                icon: {
                    anchor: {
                        x_coordinates: 15,
                        y_coordinates: 30
                    },
                    scaledSize:{
                        height: 60,
                        width: 60
                    },
                    url: markerIconUrl
                },
                lat: markerLat,
                lng: markerLong
            },
            options: {
                draggable: false,
                mapTypeControl: false,
                scrollwheel: false,
                zoom: 16
            }
        }
    };

    // options overrides
    let options = $.extend({}, defaults, overrides);

    // trigger map on in view
    $element.one('inview', function() {
        let simpleMap = new bnMaps(options);

        // enable drag and scrolling
        $element.on('click', function(){
            $element.addClass('bn-google-maps--movable');
            simpleMap.map.set('draggable', true);
            simpleMap.map.set('scrollwheel', true);
        });

        // disable drag and scrolling
        $(window).on('scroll', function () {
            if($element.hasClass('bn-google-maps--movable')){
                if ($(window).scrollTop() > 1){
                    $element.removeClass('bn-google-maps--movable');
                    simpleMap.map.set('draggable', false);
                    simpleMap.map.set('scrollwheel', false);
                }
            }
        });

    });

}

/*
 * ROUTE PLANNER
 */

export function initRoutePlanner($element,overrides) {
    let apiKey = $element.attr('data-api-key'),
        containerId = $element.parents('.bn-google-maps').find('.bn-google-maps__directions').attr('id'),
        containerMap = $element.attr('id'),
        fieldInputId = $element.parents('.bn-google-maps').find('.bn-google-maps__start').attr('id'),
        markerLat = $element.attr('data-lat'),
        markerLong = $element.attr('data-long'),
        markerIconUrl = $element.attr('data-marker');

    // default options
    let defaults = {
        apiKey: apiKey || false,
        language: vars.lang,
        containerMap: containerMap,
        mapConfig: {
            marker: {
                icon: markerIconUrl,
                lat: markerLat,
                lng: markerLong
            },
            options: {
                draggable: false,
                mapTypeControl: true,
                scrollwheel: false,
                zoom: 16
            },
            route: {
                autoComplete: true,
                containerId: containerId,
                fieldInputId: fieldInputId,
                geoLocation: true
            }
        }
    };

    // options overrides
    let options = $.extend({}, defaults, overrides);

    // trigger map on in view
    $element.one('inview', function() {
        let routePlanner = new bnMaps(options);

        // calculate route on submit click
        $element.parent().find('.bn-google-maps__form').on('submit', function(e){
            e.preventDefault();
            routePlanner.calcRoute();
        });

        // enable drag and scrolling
        $element.on('click', function(){
            $element.addClass('bn-google-maps--movable');
            routePlanner.map.set('draggable', true);
            routePlanner.map.set('scrollwheel', true);
        });

        // disable drag and scrolling
        $(window).on('scroll', function () {
            if($element.hasClass('bn-google-maps--movable')){
                if ($(window).scrollTop() > 1){
                    $element.removeClass('bn-google-maps--movable');
                    routePlanner.map.set('draggable', false);
                    routePlanner.map.set('scrollwheel', false);
                }
            }
        });

    });

}


// WEBPACK FOOTER //
// ./source/js/utilities/lib/maps.js